import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { InternalFilesFolderPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import FolderContent from 'modules/documents/components/FolderContent'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const ManagementFolderDocumentsPage = () => {
  const { navigation } = useNavigation()
  const { folderId } = useParams()
  const parsedFolderId = Number(folderId)
  const session = useCurrentSession()

  const { loading, data, error } = useQuery(InternalFilesFolderPageDocument, {
    variables: {
      folderId: parsedFolderId,
      space: SPACES.COMPANY_INTERNAL,
      companyId: session.company?.id
    }
  })

  const canEditInternalDocuments =
    (data?.documents?._policies?.companyEditInternalDocuments.can ||
      data?.documents?._policies?.companyUseCompanyDocuments.can) ??
    false

  const canSeeInternalDocuments = data?.documents?._policies?.companySeeInternalDocuments.can

  const deleteFeatureEnabled = data?.features?.featuresConnection?.nodes?.[0]?.enabled ?? false

  const [selectedFolder, setSelectedFolder] = useState<Folder>()

  const folder = data?.documents?.foldersConnection?.edges[0]?.node

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.files.managementDocuments.folderId.documentId.fullPath({
        folderId: Number(folderId),
        document_id: id
      })
  }

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={canSeeInternalDocuments}
      >
        {folder && (
          <FolderContent
            canUploadDocument={canEditInternalDocuments}
            folder={folder}
            selectedFolder={selectedFolder}
            setSelectedFolder={setSelectedFolder}
            parentRoute={navigation.files.managementDocuments.folderId.fullPath({
              folderId: parsedFolderId
            })}
            deleteFeatureEnabled={deleteFeatureEnabled}
          />
        )}
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default ManagementFolderDocumentsPage
